<template>
  <div>
    <div class="site__centered">
      <div class="family">
        <h2 class="family__title">Family</h2>
        <div class="family__body">
          <SideNav />
          <div class="family__block">
            <div class="family__header">
              <div class="family__actions">
                <button
                  class="btn btn--color-outline-dark capitalize"
                  @click="inviteParentModal"
                >
                  Invite a parent
                </button>
                <button
                  class="btn btn--color-dark capitalize"
                  @click="addStudentModal"
                >
                  {{ addChildButtonText }}
                </button>
              </div>
            </div>

            <div class="family__section">
              <h3 class="family__section-title">
                {{ camperStudent('plural') }} · {{ students.length }}
              </h3>
              <div class="family__students-grid">
                <StudentCard
                  v-for="student in students"
                  :key="student.id"
                  :member="student"
                />
              </div>
            </div>

            <div class="family__section">
              <h3 class="family__section-title">Parents · {{ parents.length }}</h3>
              <div class="family__parents-list">
                <ParentRow
                  v-for="parent in parents"
                  :key="parent.id"
                  :member="parent"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddFamilyMember
      @addNewChild="showAddNewChildModal"
    />
    <AddNewChildModal
      :is-show-modal="isShowAddNewChildModal"
      :default-gender="defaultGender"
      :family-name="user.last_name"
      :family-id="user.family_id"
      @closeModal="isShowAddNewChildModal = false"
      @updateChildrenList="prepareFamilyList"
    />
  </div>
</template>

<script>
import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'
import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'

import { getUserData } from '@/auth/utils'
import { mapGetters } from 'vuex'
import store from '@/store'

import { scrollToTop } from '@/helpers/scrollToTop'
import SideNav from '@/components/site/SideNav.vue'
import StudentCard from '@/views/Family/StudentCard.vue'
import ParentRow from '@/views/Family/ParentRow.vue'
import AddFamilyMember from '@/views/Family/AddFamilyMember.vue'
import AddNewChildModal from '@/components/site/add-new-child-modal/AddNewChildModal.vue'

export default {
  name: "FamilyList",
  components: {
    SideNav,
    StudentCard,
    ParentRow,

    AddFamilyMember,
    AddNewChildModal,
  },
  mixins: [instanceSessionCamperNames, prepareProgramRegistrationInfo],
  data() {
    return {
      user: getUserData(),
      isShowAddNewChildModal: false,
      defaultGender: null,
    }
  },
  computed: {
    ...mapGetters({
      familyList: 'family/getFamilyList',
      authSettings: 'authSettings/getAuthSettings',
    }),
    students() {
      return this.familyList.filter(member => member.role && member.role.name === 'child')
    },
    parents() {
      return this.familyList.filter(member => member.role && member.role.name === 'parent')
    },
    addChildButtonText() {
      return this.getCustomText(
        this.authSettings,
        'application_select_child_add_button',
        'Add A {camperStudent}',
        { camperStudent: this.camperStudent('singular') },
      )
    },
  },
  async created() {
    store.commit('SET_LOADING_STATUS', true)
    store.commit('family/SET_FAMILY_ID', this.user.family_id)
    await store.dispatch('family/fetchFamilyList')
    this.defaultGender = this.authSettings.default_gender
    store.commit('SET_LOADING_STATUS', false)
  },
  methods: {
    inviteParentModal() {
      this.$bvModal.show('add-family-member')
    },
    addStudentModal() {
      scrollToTop()
      this.isShowAddNewChildModal = true
    },
    showAddNewChildModal() {
      scrollToTop()
      this.$bvModal.hide('add-family-member')
      this.isShowAddNewChildModal = true
    },
    async prepareFamilyList() {
      store.commit('SET_LOADING_STATUS', true)
      await store.dispatch('family/fetchFamilyList')
      store.commit('SET_LOADING_STATUS', false)
    },
  },
}
</script>

<style scoped>

</style>